import React from 'react';
import { useNavigate } from 'react-router-dom';
import Search from 'components/alf-design/Search';
import { useForm, validate as externalValidator } from 'utils';

import { logo } from '../../assets/img';
import { Card } from '../alf-design';

function validate(values) {
  const errors = {};
  if (values?.searchPolicy) {
    if (!externalValidator.policyNumber(values.searchPolicy)) {
      errors.searchPolicy = externalValidator?.policyNumber(
        values.searchPolicy,
      );
    }
  }
  return errors;
}

const AdminPage = ({ isSearchView }) => {
  const navigate = useNavigate();
  const { handleChange, handleBlur, values, errors, touched } = useForm(
    { searchPolicy: '' },
    validate,
    true,
  );

  const onSubmit = () => {
    navigate(`/?policy=${values.searchPolicy.toUpperCase()}`, {
      replace: true,
    });
  };

  return (
    <div className="flex place-content-center">
      {isSearchView ? (
        <Card className="w-[530px] text-center py-[54px] px-[48px]">
          <img
            src={logo}
            width="225"
            alt="Slide Insurance logo"
            id="slide-insurance-logo"
            className="inline-flex justify-center mb-[30px] mt-[20px]"
          />
          <div className="w-75% inline-block">
            <Search
              name="searchPolicy"
              onChange={handleChange}
              onSubmit={onSubmit}
              placeholder="Search by Policy Number"
              value={values.searchPolicy}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
              isSearchView
            />
          </div>
        </Card>
      ) : (
        <div className="w-full inline-block">
          <Search
            name="searchPolicy"
            onChange={handleChange}
            onSubmit={onSubmit}
            placeholder="Search by Policy Number"
            value={values.searchPolicy}
            onBlur={handleBlur}
            errors={errors}
            touched={touched}
          />
        </div>
      )}
    </div>
  );
};

export default AdminPage;
